export const CAUSE = {
  ORDER: {
    LAST_UPDATED: 'lastUpdated',
  },
};
